import * as _4 from 'lodash4';

export class OpenableElement {
  id: string;
  isOpen: boolean;

  constructor(element: OpenableElement) {
    _4.merge(this, element);
  }

  static build(element: OpenableElement): OpenableElement {
    return new OpenableElement(element);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/builders/openable_element_builder.ts